<template>
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 edit_account_modal">
    <div class="my-account-title">Professional Association Information</div>
    <div class="account_section_box">
        <div class="row">
        <div class="col-lg-5 col-md-5 col-sm-5 col-xs-5">
          <label class="account_label">Professional Associations</label>
        </div>
        <div class="col-lg-7 col-md-7 col-sm-7 col-xs-7">
            <div v-for="(value, key) in CheckboxBusiness" class="form-check" v-if="FormInputs.BusinessOrganization">
                <span class="form-check-label account_p" v-if="AccountEdit.organizations">
                    <input :value="key" v-model="AccountEdit.organizations.list" class="form-check-input" type="checkbox">
                    {{key}}
                </span>
            </div>
            <div class="form-group" v-if="AccountEdit.organizations.list.indexOf('Other') >= 0">
                <span class="account_p">Please enter any other professional organizations you are associated with separated by semicolon(;).</span>
                <input type="text" v-model="AccountEdit.organizations.others" class="form-control">
            </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['AccountEdit', 'CheckboxBusiness','FormInputs']
  }
</script>



// WEBPACK FOOTER //
// EditAssociationInfo.vue?07c33db2